const state = {
  manage: {
    definition: {
      sdl: '',
      error: '',
      timer: '',
      ast: null,
    },
  },
  relationships: {},
  isFetching: false,
};

export default state;
